import {
  Card,
  formatNumber,
  Grid,
  Stack,
  Typography,
} from '@omnipresentgroup/design-system';
import type { InvoiceReport } from '@omnipresentgroup/types';

import {
  InvoiceReportPaymentStatus,
  InvoiceReportStatus,
} from '../../../../features/invoice-reports';

type Props = {
  invoice: InvoiceReport;
};

export const InvoiceReportSummary = ({ invoice }: Props) => (
  <Card>
    <Grid m="24" minItemWidth={100}>
      <Stack gap="8">
        <Typography as="span" size="12" color="subtle" weight="medium">
          Total inc. fees
        </Typography>
        <Typography as="span" size="16" weight="medium">
          {formatNumber({
            input: Number(invoice.totalAmount.amount),
            currency: invoice.totalAmount.currency,
          })}
        </Typography>
      </Stack>
      <Stack gap="8">
        <Typography as="span" size="12" color="subtle" weight="medium">
          Total exc. fees
        </Typography>
        <Typography as="span" size="16" weight="medium">
          {formatNumber({
            input: Number(invoice.totalAmountExcludingFees.amount),
            currency: invoice.totalAmountExcludingFees.currency,
          })}
        </Typography>
      </Stack>
      <Stack gap="8">
        <Typography as="span" size="12" color="subtle" weight="medium">
          Employees
        </Typography>
        <Typography as="span" size="16" weight="medium">
          {invoice.employeeCount}
        </Typography>
      </Stack>
      <Stack gap="8">
        <Typography as="span" size="12" color="subtle" weight="medium">
          Payment status
        </Typography>
        <Typography as="span" size="16" weight="medium">
          <InvoiceReportPaymentStatus
            status={invoice?.status}
            dueDate={invoice?.dueDate}
            type={invoice?.type}
          />
        </Typography>
      </Stack>
      <Stack gap="8">
        <Typography as="span" size="12" color="subtle" weight="medium">
          Approval status
        </Typography>
        <Typography as="span" size="16" weight="medium">
          <InvoiceReportStatus approved={invoice.approved} />
        </Typography>
      </Stack>
    </Grid>
  </Card>
);
